import { render, staticRenderFns } from "./PedidoTable.vue?vue&type=template&id=497ea75a"
import script from "./PedidoTable.vue?vue&type=script&lang=js"
export * from "./PedidoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports